import {
    Box,
    Flex,
    Icon,
    Icons,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeIconSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { keyframes } from "@emotion/react";
import { useTranslation } from "react-i18next";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const PaymentSpinner = () => {
    const { t } = useTranslation();
    return (
        <Flex
            direction="column"
            justifyContent="center"
            alignItems="center"
            justifySelf="center"
            gap={ThemeSpaceVariable.Large}
            px={ThemeSpaceVariable.Medium}
        >
            <Flex position="relative" w="80px" h="80px" align="center" justify="center">
                <Box
                    position="absolute"
                    w="80px"
                    h="80px"
                    borderRadius="full"
                    border="2px solid transparent"
                    borderTopColor={ThemeColorVariable.OnSurface}
                    // @ts-expect-error // ! TODO: Include animation in ThemeStyleProps for box in casper-ui-library
                    animation={`${spin} 1s linear infinite`}
                />
                <Flex
                    w="80px"
                    h="80px"
                    borderRadius="full"
                    bg={ThemeColorVariable.SurfaceDisabled}
                    align="center"
                    justify="center"
                >
                    <Icon icon={Icons.PaymentCard} size={ThemeIconSizeVariable.XLarge} />
                </Flex>
            </Flex>

            <Text fontWeight="medium" fontSize={ThemeFontSizeVariable.Large}>
                {t("confirmingPayment")}...
            </Text>
        </Flex>
    );
};

export default PaymentSpinner;
